/**
 * Factory for creating LogoutService instances based on authentication provider and support session
 */

import AuthenticationProviderEnum from '../../../config/authenticationProviderEnum';
import OnecloudLogoutService from './OnecloudLogoutService';
import StratusLogoutService from './StratusLogoutService';
import ShellLogoutService from './ShellLogoutService';
import ILogoutService from './ILogoutService';
import { ISupportSessionService } from '../../supportSession';

/**
 * Parameters for creating LogoutService strategies
 */
export interface ILogoutServiceFactoryParams {
  authenticationProvider: AuthenticationProviderEnum;
  supportSessionService: ISupportSessionService;
}

/**
 * Factory Pattern to encapsulate LogoutService creation logic
 */
export class LogoutServiceFactory {
  /**
   * Creates the appropriate LogoutService based on the authentication provider and support session
   */
  static createService(params: ILogoutServiceFactoryParams): ILogoutService {
    const { authenticationProvider, supportSessionService } = params;

    // Check support session first
    if (supportSessionService?.isSupportSession()) {
      return new ShellLogoutService();
    }

    // Then check authentication provider
    if (authenticationProvider === AuthenticationProviderEnum.coptor) {
      return new OnecloudLogoutService();
    } else {
      return new StratusLogoutService();
    }
  }

  /**
   * Returns available service types
   */
  static getAvailableServices(): string[] {
    return [
      'ShellLogoutService',
      'OnecloudLogoutService',
      'StratusLogoutService'
    ];
  }
}
